import { Controller } from "@hotwired/stimulus"

// Horizontal, scroll-snap review carousel. Prev/Next scroll by one card;
// autoplay advances on an interval and loops back at the end. Pauses on hover.
// Usage:
//   data-controller="reviews-carousel" data-reviews-carousel-autoplay-value="6000"
//   <div data-reviews-carousel-target="track"> … cards with [data-carousel-card] … </div>
//   <button data-action="reviews-carousel#prev"> / #next
export default class extends Controller {
  static targets = ["track"]
  static values = { autoplay: { type: Number, default: 0 } }

  connect() {
    this.startAutoplay()
  }

  disconnect() {
    this.stopAutoplay()
  }

  next() {
    this.scrollByCard(1)
  }

  prev() {
    this.scrollByCard(-1)
  }

  scrollByCard(direction) {
    const track = this.trackTarget
    const card = track.querySelector("[data-carousel-card]")
    const gap = parseInt(getComputedStyle(track).columnGap || "0", 10) || 24
    const amount = card ? card.offsetWidth + gap : track.clientWidth
    track.scrollBy({ left: direction * amount, behavior: "smooth" })
  }

  autoAdvance() {
    const track = this.trackTarget
    const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4
    if (atEnd) {
      track.scrollTo({ left: 0, behavior: "smooth" })
    } else {
      this.scrollByCard(1)
    }
  }

  startAutoplay() {
    if (this.autoplayValue > 0 && !this.timer) {
      this.timer = setInterval(() => this.autoAdvance(), this.autoplayValue)
    }
  }

  stopAutoplay() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }

  // Bind to mouseenter/mouseleave on the root element to pause on hover.
  pause() {
    this.stopAutoplay()
  }

  resume() {
    this.startAutoplay()
  }
}
